var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreimg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 109,
    viewBox: "0 0 106 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 106,
    height: 107,
    fill: "url(#pattern0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1687 84.0393H23.4278C25.8416 84.0393 28.1943 83.2807 30.1535 81.8708L63.3436 57.9864C66.5719 55.6632 70.0809 53.1773 73.9873 53.9253C74.6771 54.0574 75.4362 54.2404 76.2688 54.4853L59.1952 19.3337C55.7125 12.1634 45.3842 12.5015 42.3779 19.8841L19.8477 75.2115C19.4157 76.3346 18.8671 78.5661 19.029 80.8424C19.1735 82.8726 21.1334 84.0393 23.1687 84.0393Z",
    fill: "#F25A2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1382 75.9792L81.2585 67.1514L85.0967 78.6659C85.0967 86.721 78.5667 93.251 70.5116 93.251H63.2191L65.1382 75.9792Z",
    fill: "#FEBA3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.746 93.2509L50.9368 84.0393V93.2509H31.746Z",
    fill: "#F25A2B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_502_131",
    transform: "scale(0.00943396 0.00934579)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_502_131",
    width: 106,
    height: 107,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABrCAYAAACffRcyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIASURBVHgB7dddUcNAFEDhuyhAAjhAQqsACQUHoACqACSABBRQFFAHxAF1EO62CVM6/DyV7pk538zNZtK8ncnOtsQf+r4/yeV4GO3HspSy+u2F8t3DIc5VziwM9F+6nEXOPKN1uz9+CZWBapSb2ETS4dxnrOvtB5+hhkjPOWehFixzpuOWuB3qNYzUmkWGmtabo3rJSHW7M1J7Jtnmtt6U4eDwFmpV3fpO6xc1CbWsnh0uaqhZqHXndet7D/8rtW5VQ/Wh5h2FEAwFYSgIQ0EYCsJQEIaCMBSEoSAMBWEoCENBGArCUBCGgjAUhKEgDAVhKAhDQRgKwlAQhoIwFIShIAwFYSgIQ0EYCsJQEIaCMBSEoSAMBWEoCENBGArCUBCGgjAUhKEgDAVhKAhDQRgKwlAQhoIwFIShIAwFYSgIQ0EYCsJQEIaCMBSEoSAMBWEoCENBGArCUBCGgjAUhKEgDAVhKAhDQRgKwlAQhoIwFIShIAwFYSgIQ0EYCsJQEIaCMBSEoSAMBWEoCENBGArCUBCGgqihulDrljXUS6h161APodY9lnrt+/45l0moRV0p5XQ8TMxDrZrWyzpUFlvkch1qzTzbdPWmbD/NLfAql7vQoa1iE+l+fFB238hYJ7nc5sxCh7DIuRy/pFH56e0h2HlsDhnHoX3qcpY5T7uBRh8BSVNjulzexQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreimg1);
export default __webpack_public_path__ + "static/media/coreimg1.f4dc31c1ae3cd4708dc71c53d2889521.svg";
export { ForwardRef as ReactComponent };